import React from 'react';
import './spinner.css';

export default () => {
  return <div className="spinner" />;
};



// WEBPACK FOOTER //
// ./src/Spinner.js